import { Button } from "@coval/ui"
import { Download } from "lucide-react"

import { TRACKING_EVENTS, useAnalytics } from "@/lib/analytics"

import {
  downloadRunResultsCsv,
  type BuildRunResultsCsvParams,
} from "./runResultsCsvExport"

/** Downloads the results the table currently shows, in the order it shows them. */
export const RunResultsCsvExportButton = (
  csvParams: BuildRunResultsCsvParams,
) => {
  const { trackEvent } = useAnalytics()

  return (
    <Button
      variant="secondary"
      icon
      tooltip="Export results as CSV"
      disabledReason="No results to export"
      onClick={() => {
        const csv = downloadRunResultsCsv(csvParams)

        trackEvent(TRACKING_EVENTS.RUNS.CSV_EXPORT, {
          table_type: "run_results",
          row_count: csvParams.rows.length,
          columns: csv.columnCount,
        })
      }}
      disabled={csvParams.rows.length === 0}
    >
      <Download className="w-4 h-4" />
    </Button>
  )
}
